import { ResetPasswordType } from "../../types/Auth";
import { patch } from "../../utils/axios-config";
import { AUTH_RESET_PASSWORD } from "../../utils/constants";

export const resetPassword = async (data: ResetPasswordType) => await patch<ResetPasswordType, string>(AUTH_RESET_PASSWORD, data);